<template>
  <d-container fluid class="px-4 main-content-container">
    <!-- Page Header -->
    <d-row no-gutters class="py-4 page-header">
      <div class="mb-0 text-center col-12 text-sm-left">
        <span class="text-uppercase page-subtitle d-block">Lista</span>
        <h3 class="page-title d-inline">Comentários</h3>
      </div>
    </d-row>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="mb-4 card-small">
          <div class="card-header border-bottom d-flex justify-content-around">
            <d-col cols="12" md="5">
              <h6 class="m-0">Filtros para listagem</h6>
            </d-col>
            <d-col cols="12" md="7">
              <form class="main-sidebar__search">
                <d-row>
                  <d-col cols="4">
                    <d-select v-model="pagination.status">
                      <option :value="null">Filtro por status</option>
                      <option :value="status.value" v-for="status in statuses" :key="status.value">{{ status.name }}</option>
                    </d-select>
                  </d-col>
                  <d-col cols="8">
                    <div class="ml-3 input-group input-group-seamless">
                      <div class="input-group-prepend">
                        <div class="input-group-text">
                          <i class="fas fa-search"></i>
                        </div>
                      </div>
                      <input
                        class="navbar-search form-control"
                        type="text"
                        placeholder="Procurar por algo..."
                        aria-label="Search"
                        v-model="pagination.search"
                      >
                    </div>
                  </d-col>
                </d-row>
              </form>
            </d-col>
          </div>
          <div class="p-0 pb-3 text-left card-body">
            <div class="table-overflow">
              <comment-table :comments="comments.list" />
            </div>
            <pagination :total-items="comments.total_items" :pagination.sync="pagination"></pagination>
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import CommentTable from '../components/CommentListTable.vue';

export default {
  name: 'comment-list',
  components: {
    Pagination,
    CommentTable,
  },
  data() {
    return {
      pagination: {
        search: '',
        status: null,
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
    ...mapState({
      statuses: state => state.comment.statuses,
    }),
    comments() {
      const { commentList } = this.$store.state.comment;
      if (commentList && commentList.list.length) {
        return commentList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getCommentList',
    ]),
    getList() {
      this.getCommentList(this.pagination);
    },
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    this._onPagination = pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getList();
    };
    Events.$on('update:pagination', this._onPagination);
    this.getList();
  },
  beforeDestroy() {
    Events.$off('update:pagination', this._onPagination);
  },
};
</script>

<style lang="scss" scoped>
</style>
